angular.module('bribac.components.messageEditorModal', [,
  'bribac.values',
  'bribac.entities.kinds',
  'bribac.services.api',
  'bribac.validators.requiredWithTrim'
])

  .component('messageEditorModal', {
    templateUrl: 'message-editor-modal-component.html',
    controller: 'MessageEditorModalComponentCtrl',
    bindings: {
      close: '&',
      dismiss: '&',
      modalInstance: '<',
      resolve: '<'
    }
  })

  .controller('MessageEditorModalComponentCtrl', function(
    state,
    KINDS,
    SMS_MAXLENGTH,
    api
  ) {
    var $ctrl = this

    $ctrl.SMS_MAXLENGTH = SMS_MAXLENGTH
    $ctrl.translationValues = {
      maxLength: SMS_MAXLENGTH
    }

    $ctrl.sendMessage = function() {
      var $form = $ctrl.form

      if ($form._submitting || $form.$invalid) {
        return
      }

      $form._submitting = true
      $form._submitError = ''

      api.post(KINDS.MESSAGE, {
        author: {id: state.currentAgent.id},
        to: {id: $ctrl.resolve.subject.id},
        text: $ctrl.messageText
      })
        .finally(function() {
          $form._submitting = false
        })
        .then(
          function success(request) {
            // Use this callback which can be called immediately when the API
            // response is resolved, instead of waiting to pass the result to
            // `$ctrl.close()` which closes the modal.
            $ctrl.resolve.callbacks.onSaveSuccess(request.data)
            $ctrl.messageSent = true
          },

          function error(request) {
            $form._submitError = (request.data && request.data.errorMessage)
              ? request.data.errorMessage
              : (request.statusText || 'Unknown error')
          }
        )
    }

  })
